module.exports = __webpack_public_path__ + "static/media/hero-banner-2022.d8f9b616.png";